import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'range'
})

export class RangePipe implements PipeTransform {
    transform(value: any, args: any): any {
        const arr = [];
        for (let i = value[0]; i <= value[value.length - 1]; i++){
            arr.push(i);
        }
        return arr;
    }
}
